import axios from 'utils/axios';

export default {
  fetchAll: () => {
    return axios.get('employees').then(({data: response}) => Promise.resolve(response));
  }
}
